import { Component } from '@angular/core';
import { BlurComponent } from './blur.component';

@Component({
  selector: 'eid-blur-mobile',
  templateUrl: './blur.mobile.component.html',
  styleUrls: ['./blur.mobile.component.scss']
})
export class BlurMobileComponent extends BlurComponent {}
